<template>
    <div class="profit-chart">
        <div>
            <div class="profit-title">
                <div class="title-line"></div>
                <span class="title-content">收益走势</span>
            </div>
            <div ref="profitChart" style="width: 595px; height: 300px"></div>
        </div>
        <div class="sep-line"></div>
        <div v-if="performanceList.length">
            <div class="profit-title">
                <div class="title-line"></div>
                <span class="title-content">业绩走势</span>
            </div>
            <div ref="performanceChart" style="width: 595px; height: 300px"></div>
        </div>
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import * as echarts from "echarts/index.common";

export default {
    name: "ProfitDetail",
    components: {},
    mixins: [mixin],
    props: {
        profitList: {
            type: Array,
            default: () => {
                return [];
            }
        },
        performanceList: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },
    data() {
        return {
            defaultOption: {
                title: {
                    show: false
                },
                color: ["#E60012"],
                grid: {
                    top: 10,
                    right: 50,
                    bottom: 50
                },
                tooltip: {
                    trigger: "axis"
                },
                yAxis: {
                    type: "value",
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        fontSize: "12px",
                        color: "#666666"
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: ["#EAEAEA"],
                            type: "dashed"
                        }
                    }
                }
            }
        };
    },
    watch: {
        profitList(val) {
            if (val.length > 0) {
                this.$nextTick(() => {
                    this.initProfitChart();
                });
            }
        },
        performanceList(val) {
            if (val.length > 0) {
                this.$nextTick(() => {
                    this.initPerformanceChart();
                });
            }
        }
    },
    methods: {
        // 收益走势图
        initProfitChart() {
            let categorys = [];
            let values = [];
            this.profitList.forEach((item) => {
                if (item.totalprofit != null) {
                    categorys.push(this.$util.fmtDate(item.profitdate));
                    values.push(item.totalprofit);
                }
            });
            const chartDom = this.$refs.profitChart;
            const myChart = echarts.init(chartDom);
            let option = {
                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    axisLabel: {
                        align: "center",
                        fontSize: "12px",
                        color: "#666666",
                        margin: 15
                    },
                    data: categorys
                },
                series: [
                    {
                        data: values,
                        type: "line",
                        smooth: true
                    }
                ]
            };
            option = Object.assign(option, this.defaultOption);
            myChart.setOption(option);
        },
        // 业绩走势图
        initPerformanceChart() {
            let categorys = [];
            let values = [];
            this.performanceList.forEach((item) => {
                if (item.RATE != null) {
                    categorys.push(this.$util.fmtDate(item.DATE));
                    values.push(item.RATE);
                }
            });
            const chartDom = this.$refs.performanceChart;
            const myChart = echarts.init(chartDom);
            let option = {
                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    axisLabel: {
                        align: "center",
                        fontSize: "12px",
                        color: "#666666",
                        margin: 15
                    },
                    data: categorys
                },
                yAxis: {
                    axisLabel: {
                        fontSize: "12px",
                        color: "#666666",
                        formatter: "{value}%"
                    }
                },
                series: [
                    {
                        data: values,
                        type: "line",
                        smooth: true
                    }
                ]
            };
            option = Object.assign(option, this.defaultOption);
            myChart.setOption(option);
        }
    }
};
</script>

<style lang="scss" scoped>
.profit-chart {
    box-sizing: border-box;
    display: flex;
    border: 1px solid #f1f1f1;
    margin-bottom: 20px;
    .sep-line {
        width: 1px;
        height: 357px;
        background: #f1f1f1;
    }
    .profit-title {
        display: flex;
        align-items: center;
        margin-bottom: 12px;
        padding: 20px 20px 0;
    }
}
</style>
